import _ from 'lodash';
const parse = (params: string): Record<string, string> => _.chain(params).replace('?', '').split('&').map((pair) => _.split(pair, '=', 2)).fromPairs().value();
function stringify(obj: Record<string, unknown>): string {
  return _.chain(obj)
    .toPairs() // chuyển thành mảng [[key, value], ...]
    .filter(([_, value]) => value !== undefined) // loại bỏ undefined
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(String(value));
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&')
    .value();
}
const QueryString = {
  parse,
  stringify,
};

export default QueryString;
